import { connect } from 'react-redux';
import Component from './component';
import withTracker from '../AppHOC';

const mapStateToProps = () => ({});

export default withTracker(connect(mapStateToProps, null)(Component));
